import React, { useRef, useState } from "react";
import { Row, Col, Container } from "react-bootstrap";
//import videoSrc from '../assets/images/videos/1.mp4.crdownload';
import playIcon from "../assets/images/service-page/play-btn.svg"; // Path to your play icon
import pauseIcon from "../assets/images/service-page/pause-btn.svg"; // Path to your pause icon
import HeadingLines from "../assets/images/heading-lines.svg";

function MemoryCarePersonalCare({ data }) {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlayPause = () => {
    if (videoRef.current.paused) {
      videoRef.current.play();
      setIsPlaying(true);
    } else {
      videoRef.current.pause();
      setIsPlaying(false);
    }
  };



  return (
    <>
      <section className="memory-care-personal-care">
        <Container>
          <Row className="align-items-center">
            <Col sm="12">
              <div className="common-header">
                <img src={HeadingLines} alt="" />
                <h2>{data?.title}</h2>
              </div>
              <div className="memory-care-personal-care-box">
                <div className={isPlaying ? "pause-video" : "play-video"}>
                  <video
                    ref={videoRef}
                    src={`${process.env.REACT_APP_PHP_BACKEND_MEDIA_URL}${data?.video}`}
                  />
                </div>
                <button
                  onClick={handlePlayPause}
                  className="play-pause-button custom-bttn green-bttn"
                >
                  <img
                    src={isPlaying ? pauseIcon : playIcon}
                    alt={isPlaying ? "Pause Icon" : "Play Icon"}
                  />
                  {isPlaying ? "Pause Video" : "Play Video"}
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}

export default MemoryCarePersonalCare;
